import React,{useState, useEffect} from 'react';
import Style from './carousel-component.module.scss';
import {LeftCircleOutlined,RightCircleOutlined} from "@ant-design/icons";
import Card from '../Card/card-component';
import {useSelector} from "react-redux";

interface CarouselProp{
    concursos: Array<any>,
}
const Carousel:React.FC<CarouselProp> = (prop)=> {
    let pagination:any =[];
    let actualEvents:any =[];
    const estiloCard:any = "";
    let count: number =0;
    let [page, setPage] = useState<any>([]);

    let [actualPage, setActualPage] = useState<number>(0);
    let i=0;


    useEffect(()=>{
      
        setActualPage(0);
 
        setPage(()=> prop.concursos.map(c=>{  
            if(i<4){
                i++;
                return [...pagination,{key:count,concurso:c}]; 

            }else{
                count++;
                i=0;
                return [...pagination,{key:count,concurso:c}]; 

            } 
        }))
 
    },[]);
    useEffect(()=>{
        const root = document.documentElement;
        root?.style.setProperty(
          "card",
          "animation"
        );
    },[actualPage])

    useEffect(()=>()=>{
        count = 0;
        setPage([]);
    },[]);
 
    return (
        <div className={Style.container}>
            <div className={Style.carousel}>
            <div className={Style.arrow}>
            <button onClick={()=>{return actualPage!= 0?setActualPage(actualPage-1):null}}><LeftCircleOutlined className={Style.icon}/></button>
            </div>
            <div className={Style.content}>
                {page?.map((c:any)=>(
                        actualPage === c[0].key?
                        <Card  concursoId={c[0].concurso.concursoID} titulo={c[0].concurso.titulo} cardArquivoUrl={c[0].concurso.cardArquivoUrl} />:null
                    )
                    )}
            </div>
            <div className={Style.arrow}>
                <button onClick={()=>setActualPage(actualPage+1)}><RightCircleOutlined className={Style.icon}/></button>
            </div>
            </div>
        </div>
    )
};

export default Carousel;
